import authInterceptor from "../AuthInterceptor";

export const EmployeeAPI = {
    addEmploye: (body) =>
        authInterceptor.post(`ranking-api/add-employee/`, body)
            .then((response) => response.data)
            .catch((error) => error.response),
    deleteEmploye: (bodyData) =>
        authInterceptor.post(`ranking-api/delete-employee/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response)
}